/**
 * ParticipantList Component
 *
 * Displays list of participants with their username and app.
 */

import type { RaceParticipant } from '@/types/race';
import { getAppById } from '@/config/apps';
import styles from './Race.module.css';

interface ParticipantListProps {
  participants: RaceParticipant[];
  maxParticipants?: number;
}

const APP_ICONS: Record<string, string> = {
  addition: '+',
  multiplication: '\u00d7',
  subtraction: '-',
  division: '\u00f7',
};

export function ParticipantList({ participants, maxParticipants }: ParticipantListProps) {
  if (participants.length === 0) {
    return (
      <div className={styles.participantListEmpty}>
        <p>Waiting for participants to join...</p>
      </div>
    );
  }

  return (
    <div className={styles.participantListContainer}>
      <div className={styles.participantCount}>
        {participants.length}
        {maxParticipants && ` / ${maxParticipants}`} participants
      </div>
      <div className={styles.participantList}>
        {participants.map((participant, index) => {
          const app = getAppById(participant.app_name);
          return (
            <div
              key={participant.id}
              className={styles.participantCard}
              style={{ '--app-color': app?.color || '#666' } as React.CSSProperties}
            >
              <span className={styles.participantIndex}>{index + 1}</span>
              <span className={styles.participantName}>{participant.username}</span>
              <span className={styles.participantApp}>
                <span className={styles.appIcon}>
                  {APP_ICONS[participant.app_name] || '?'}
                </span>
                {app?.shortName || participant.app_name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
